module.exports = __webpack_public_path__ + "img/c02_unitstartechspearmanchampion_Normal_ua.e562f0c2.webp";